

import React,{useMemo} from 'react';
import styles from './index.less';
styles;
export const Loading=()=>{
  return (
    <div className="ldio-2oha7mxue8v">
      <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
    </div>
  )
}

export default React.memo(Loading);
